import styled from "react-emotion";
import { themeGet, width, space, color } from "styled-system";

export const SubNavigationBar = styled("section")`
  ${width}
  ${space}
  ${color}
  height: 48px;
  min-height: 48px; 
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: 'proxima-nova', sans-serif;
  border-bottom: 1px solid ${themeGet("colors.greyscale.3")};
  overflow-y: hidden; /* This is added to prevent IE11 making the bar changing heights in weird manner. */

  h3 {
    margin: 0;
    font-weight: bold;
    display: inline-block;
  }

  section .ant-divider-vertical {
    margin: 0 18px;
    height: 1.2em;
  }

  section {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
`;
